const searchButton = document.querySelector('.header-search__toggle');
const searchBox = document.querySelector('.header-search__wrapper');
searchButton.addEventListener('click', function () {
  searchBox.classList.toggle('show-search');
  searchButton.classList.toggle('close-toggle');
  const expanded = this.getAttribute('aria-expanded') === 'true' || false;
  this.setAttribute('aria-expanded', !expanded);
  searchBox.setAttribute('aria-hidden', expanded);
});
